import React from "react";

export const StructuredData = () => {
  const restaurantSchema = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    name: "Indian Food Caterers | Catering Services in Orlando, FL",
    address: {
      "@type": "PostalAddress",
      streetAddress: "5829 Grand National Dr Ballroom Building",
      addressLocality: "Orlando",
      addressRegion: "FL",
      postalCode: "32819",
    },
    image: "https://www.tablacatering.com/shared/cateringNationwideLogo.jpg",
    email: "tablacatering@tablacuisine.com",
    telePhone: "(407) 726-4020",
    url: "https://www.tablacatering.com/",
    paymentAccepted: ["cash", "check", "credit card", "invoice", "paypal"],
    openingHours: "Mo,Tu,We,Th,Fr,Sa,Su 09:00-23:00",
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "09:00",
        closes: "23:00",
      },
    ],
    geo: {
      "@type": "GeoCoordinates",
      latitude: "28.465380",
      longitude: "-81.479172",
    },
    priceRange: "$",
  };

  const websiteSchema = {
    "@context": "http://schema.org/",
    "@type": "WebSite",
    url: "https://www.tablacatering.com/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.tablacatering.com/?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(restaurantSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
    </>
  );
};
